<template lang="pug">
  v-list( dense nav)
    .d-flex.fd-column.flex-1(v-if="procesos && !procesos.length")
      div(v-for="a in 3")
        v-skeleton-loader(type='list-item-avatar-two-line')
        v-skeleton-loader(type='divider')
    v-list-item(v-else v-for='(o, index) in procesos' :key='index', @click="o.done && downloadFile(o)")
      //- strong {{o}}
      v-list-item-avatar
        v-progress-circular(indeterminate='' color='primary', v-if="!o.done && !o.error"  :width="3")
        v-icon.background.success--text(v-if="o.done")
          | check_circle
        v-icon.background.error--text(v-else-if="o.error")
          | close
      v-list-item-content
        v-list-item-title.font-size-12 {{o.name}}
        v-list-item-subtitle.text-muted.font-size-11(v-if="o.done") Terminó en  {{o.time}}
        v-list-item-subtitle.font-size-11.error--text(v-else-if="o.error") Error: {{o.message}}
        v-list-item-subtitle.font-size-11.info--text(v-else-if="!o.done && !o.error") Exportando...
      v-list-item-action
        .d-flex
          v-btn( :disabled="!o.done" fab color="info white--text" @click.stop="downloadFile(o)")
            v-icon  arrow_downward
          v-btn.ml-3( :disabled="!o.done" fab color="white error--text" @click.stop="eliminar(o.id)")
            v-icon  delete
    .d-flex.ma-2.mt-3
      v-btn(color='error' block :small="!isMovil" :loading="!procesos.length"   :disabled="!procesos.length" @click='eliminarTodasLasDescargas()')
        | Eliminar  descargas
</template>

<script>
  import { apiGet, apiDelete, notify }  from '../util/general.js'
  import moment             from 'moment'
  export default {
    name: 'procesos_handler',
    data () {
      return {
        procesos: [],
        interval: ''
      }
    },
    created () {
      var vm = this
      vm.rebuildProcessInterval()
    },
    computed : {
      isMovil () {
        var vm = this
        return vm.$vuetify.breakpoint.smAndDown
      }
    },
    methods: {
      eliminarTodosLosProcesos () {
        var vm = this
        vm.procesos.forEach(e => {
          e.done && vm.eliminar(e)
        })
      },
      openUrl (o) {
        var vm = this
        window.open(o.return.path, o.return.target || '_blank')
        window.location.reload(true)
        vm.eliminar(o)
      },
      rebuildProcessInterval () {
        var vm = this
        if (vm.interval) clearInterval(vm.interval)
        vm.fetchProcesos()
        vm.interval = setInterval(function () {
          vm.fetchProcesos()
        }, 3000)
      },
      clearProcessInterval () {
        var vm = this
        if (vm.interval) clearInterval(vm.interval)
      },
      fetchProcesos () {
        // No se si deberiamos ponerlo aca, pero aca es donde más se rellena
        var vm = this
        var url = '/procesos/'
        var obj = {}
        // Antes de todo, cortar todos los interval de los procesos actuales
        for (var i = 0; i < vm.procesos.length; i++) {
          clearInterval(vm.procesos[i].interval)
        }

        apiGet(vm, url, obj, function (data) {
          if (!data.lista || data.lista.length === 0) {
            vm.procesos = []
            vm.$store.dispatch('setCountAllDownloands', vm.procesos.length)
            vm.clearProcessInterval()
            vm.$store.dispatch('closeProcesos')
          } else {
            // Empezar los intervals de los procesos para el cronometro
            vm.procesos = data.lista;
            vm.$store.dispatch('setCountAllDownloands', vm.procesos.length)
            for (var i = 0; i < vm.procesos.length; i++) {
              vm.procesos[i].time = vm.getTime(vm.procesos[i].fechaInicio);
              (function (i) {
                if (!vm.procesos[i].done) {
                  vm.procesos[i].interval = setInterval(function () {
                    vm.procesos[i].time = vm.getTime(vm.procesos[i].fechaInicio)
                  }, 1000)
                }
              })(i);
            }

            if (vm.procesos.length === 0) {
              vm.procesos = []
              vm.clearProcessInterval()
              vm.$store.dispatch('closeProcesos')
            } else {
              // Si es que hay, hay que revisar si ya todos estan terminados
              // Si ya estan todos terminados ya no hay que ir a buscar procesos
              var hayAlgunoPendiente = false
              for (var l = vm.procesos.length - 1; l >= 0; l--) {
                if (!vm.procesos[l].done) {
                  hayAlgunoPendiente = true
                }
                if (!hayAlgunoPendiente) {
                  vm.clearProcessInterval()
                }
              }
            }
          }
        }, function (err) {
          notify(vm, 'error', 'Error', err.message)
        }, function () {
        })
      },
      downloadFile (o) {
        // Aca debe estar el path, una vez que descarga, tiene que ir a eliminar el proceso
        window.open(o.path)
        this.eliminar(o.id)
      },
      eliminar (id, callback) {
        var vm = this
        var url = '/procesos/'
        var obj = {
          id      : id
        }
        apiDelete(vm, url, obj, function (data) {
          if (!callback) vm.rebuildProcessInterval()
          else callback(null)
        }, function (err) {
          callback ? callback(err) : notify(vm, 'error', 'Error', err.message)
        })
      },
      getTime (fechaInicio) {
        var rightNow   = moment()
        var milisecond = rightNow.diff(moment(fechaInicio))
        var tempTime   = moment.duration(milisecond);

        var hour = tempTime.hours() + ''
        if (hour === '0') hour = '00'
        else if (hour.length === 1) hour = '0' + hour

        var minute = tempTime.minutes() + ''
        if (minute === '0') minute = '00'
        else if (minute.length === 1) minute = '0' + minute

        var second = tempTime.seconds() + ''
        if (second === '0') second = '00'
        else if (second.length === 1) second = '0' + second
        return hour + ':' + minute + ':' + second
      },
      fetchEliminarNotificaciones (index, callback) {
        var vm = this
        vm.eliminar(vm.procesos[index].id, err => {
          if (err) {
            callback(err)
          } else {
            index++
            if (index === vm.procesos.length) callback(null)
            else vm.fetchEliminarNotificaciones(index, callback)
          }
        })
      },
      eliminarTodasLasDescargas () {
        var vm = this
        vm.fetchEliminarNotificaciones(0, err => {
          if (err) {
            notify(vm, 'error', 'Error', err.message)
            return
          }

          notify(vm, 'success', 'Exito', 'Las descargas se eliminarón correctamente')
          vm.rebuildProcessInterval()
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .procesos
    position fixed
    bottom 5px
    right 1px
    z-index: 100;
    .proceso-container
      background-color white
      text-align left
      margin-bottom 5px
      color #979797
      display flex
      position relative

      .icon-container
        text-align center
        width 40px
        padding 10px
        color white

      .message-container
        display flex
        flex-direction column
        padding 5px
        width: 100%;
        .message-text
          color: #2d4258;
          font-size: .75rem;
          padding-right 4px
        .bold
          font-weight: 700;

        .error-message-text
          margin-left 5px
          color #974758

        .action-message-text
          margin-left 5px
          color #447F93
          cursor pointer

      .close-container
        position absolute
        top 1px
        right 2px
        cursor pointer


      .bg-red
        background-color #974758

      .bg-green
        background-color #4D8336

      .bg-blue
        background-color #447F93

      .spin
        padding 5px

      .subtitle
        font-size 12px
        margin-bottom 0px

      .link
        color blue
        cursor pointer

      .color-white
        color: white

  @media (max-width: 500px)
    .procesos
      top 1px
      width 100%
      height: fit-content;
      .proceso-container
        margin 5px
</style>



// WEBPACK FOOTER //
// c_procesos_handler.vue?0df1dd14